<template>
    <div class="group">
        <div class="name">{{name}}</div>
        <Row>
        <slot></slot>
        </Row>
    </div>
</template>
<script>
export default {
    name:'CardGroup',
    props:{
        name:{
            type:String,
            default:'组名称'
        }
    },
    data(){
        return {
            
        }
    }
}
</script>
<style lang="less" scoped>

.group {
    width:100%;
    min-height: 100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    padding: 24px;
    
    .name{
        height:22px;
        font-size:14px;
        font-weight:bold;
        color:rgba(70,76,91,1);
        line-height:22px;
        margin-bottom: 8px;
    }
}

</style>
